import { makeAutoObservable, runInAction } from 'mobx'
import Settings from '../components/settings'
import * as _ from 'lodash/fp'
import { singletonFetch } from '../utils/singletonFetch'

export class ValidateNewsletterController {
  constructor() {
    makeAutoObservable(this)
  }

  validation_data = {}
  isLoading = false

  get isAllValid() {
    let isAllValid = _.pipe(
      () => this.validation_data?.validation_data ?? {},
      Object.values,
      _.all(
        _.pipe(
          Object.values,
          _.all(p => p.valid)
        )
      )
    )
    return isAllValid()
  }
  /**
   * @param {import('./eventGroup').EventGroup[]} eventGroups
   * @param {import('./participant').Participant[]} ps
   * @param {import('./customer').Customer} customer
   * @returns {Promise<{[id:string]:any}>}
   */
  async validate(eventGroups, ps, customer, coupon = null) {
    this.isLoading = true
    const validation = await this.validateNewsletter(eventGroups, ps, customer, coupon)

    runInAction(() => {
      this.validation_data = validation
      this.isLoading = false
    })

    return validation
  }

  /**
   * @param {import('./eventGroup').EventGroup[]} eventGroups
   * @param {import('./participant').Participant[]} ps
   * @param {import('./customer').Customer} customer
   * @returns {Promise<{[id:string]:any}>}
   */
  async validateNewsletter(eventGroups, ps, customer, coupon = null) {
    return await singletonFetch(
      'validation/newsletter' +
        eventGroups.map(eg => eg.id).join(',') +
        ps.map(p => p.id).join(','),
      Settings.getSetting('/cart/validation/newsletter', 'cart'),
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          cart_items: Object.fromEntries(eventGroups.map(eg => [eg.id, eg])),
          participants: Object.fromEntries(ps.map(p => [p.id, p])),
          customer: customer,
          coupon: coupon
        })
      }
    ).then(response => response.json())
  }

  /**
   * @return {{[id:string]:{errors:{[id:string]:string}}}}
   */
  get validation() {
    return this.validation_data.validation_data
  }
}
